import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { CustomerOrderTypesDataGrid } from "src/components/views/erp/sales/masterData/customerOrderTypes/CustomerOrderTypesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/customerOrderTypes")({
	staticData: { title: i18n.t("customer_order_types"), legacyViewKey: "customerOrderTypesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <CustomerOrderTypesDataGrid />;
}
